import React from 'react'
import Helmet from 'react-helmet'
import CourseMap from 'modules/common/components/map'
import { getSeoForPage } from 'modules/seo'

const seoData = getSeoForPage('courses')

const CoursesMapPage = (props) => (
  <div>
    <Helmet title={seoData.title} meta={seoData.meta} />
    <CourseMap
      {...props}
    />
  </div>
)

export default CoursesMapPage





// WEBPACK FOOTER //
// ./src/modules/pages/CoursesMapPage.js